module.exports = "<div class=\"row gris-base\"> <div ui-view=principal@></div> <div ui-view=indicators@></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/trainingResearch/list/index.html
// module id = 621
// module chunks = 0